"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { toast as sonnerToast } from "sonner";
import { CustomToast as CustomToastComponent } from "./components/CustomToast";
import { toastConfig } from "./toast.config";
import { ToastProps } from "./types";

/** I recommend abstracting the toast function
 *  so that you can call it without having to use toast.custom every time. */
export function toast(toast: Omit<ToastProps, "id">) {
  return sonnerToast.custom(id => <CustomToast id={id} title={toast.title} description={toast.description} type={toast.type} button={{
    label: toast.button?.label
  }} />, {
    style: {
      borderRadius: "0.75rem" // rounded-xl (to round the border, because originally it is not.)
    },
    duration: toast.duration ?? 2000
  });
}
const CustomToast = props => {
  const $ = _c(6);
  const {
    type,
    title,
    description,
    id
  } = props;
  const config = toastConfig[type || "default"];
  let t0;
  if ($[0] !== config || $[1] !== description || $[2] !== id || $[3] !== title || $[4] !== type) {
    t0 = <CustomToastComponent id={id} title={title} description={description} config={config} type={type} />;
    $[0] = config;
    $[1] = description;
    $[2] = id;
    $[3] = title;
    $[4] = type;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export default CustomToast;